import { AbstractControl, UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';


export function encuestaValidateDesc(): ValidatorFn {
	return ( form: AbstractControl ) => {
		const MAX_LENGTH = 250;
		let valid: ValidationErrors = null;
		let controls: UntypedFormControl[] = form['controls'];

		// Limpio los errores en todas las descripciones
		let controlNames: string[] = Object.keys( form['controls'] ).filter( key => key.endsWith( '-desc' ) );
		if( controlNames != null && controlNames.length > 0 )
			controlNames.forEach( name => controls[ name ].setErrors( null ) );

		// Hay que buscar que motivo seleccionó el usuario, y luego verificar si llenó la descripción de ese motivo
		let motivo: string = controls['motivo'].value;
		if( motivo ) {
			let descControlName: string = motivo.replace( '_', '-' ).toLowerCase() + '-desc';
			let descControl: UntypedFormControl = controls[descControlName];
			let desc: string = descControl.value? descControl.value.trim(): '';

			if( desc == '' )
				valid = { descRequired: true };
			else if( desc.length > MAX_LENGTH )
				valid = { descMaxLength: true };

			if( descControl.dirty && valid )
				descControl.setErrors( valid );
		}
		return valid;
	};
}